window.pages.calculator = {
    init: function () {
        window.components.calculatorForm.init();

        $(function () {
            const pathname = $(location).attr('pathname'); 
            if (pathname == '/calculadora') {
                $('.calc-header').show();
                $('.product-header').hide();
            }
        });

    },
};
